
import MaintenanceSection from './components/MaintenanceSection';




function Maintenance() {
  return (
    <div className="min-h-fit-screen">
   
      <main>
        <MaintenanceSection />
      </main>
    
    </div>
  );
}

export default Maintenance;